import ReportPrism from './reportPrism'
export default ReportPrism
